import ArtworksResults from "./ArtworksResults"
import GalleriesResults from "./GalleriesResults"
import ExhibitionsResults from "./ExhibitionsResults"
import Wrapper from "../../components/Layout/Wrapper"
import Container from "../../components/Layout/Container"
import { useState, useEffect } from "react"
import { HelmetTitle } from "../../components/Layout/HelmetTitle"
import ArtworksPage from "../ArtworksPage"
import styles from "./searchpage.module.css"
import classNames from "classnames"

const Search = ({ results, searchTerm, filters }) => {
  const [showartworks, setShowartworks] = useState(results.artworks.total > 0)
  const [showgalleries, setShowgalleries] = useState(
    results.artworks.total == 0 && results.galleries.total > 0,
  )
  const [showexhibitions, setShowexhibitions] = useState(
    results.artworks.total == 0 &&
      results.galleries.total == 0 &&
      results.exhibitions.total > 0,
  )
  const [totalArtworks, setTotalArtworks] = useState(results.artworks.total)
  const noResults =
    results.artworks.total == 0 &&
    results.galleries.total == 0 &&
    results.exhibitions.total == 0

  console.log(searchTerm.search)
  return (
    <>
      <Wrapper>
        <HelmetTitle title="Search" />
        <div className={`bg-light py-3 ${styles.searchBar}`}>
          <Container>
            <div
              className={`${styles.searchHeader} d-flex justify-content-between justify-content-md-start  fs-13px`}>
              <span className={styles.searchResults}>
                Search results for <b>{searchTerm}</b>:
              </span>
              <a
                className={`${
                  showartworks ? classNames(styles["underline"]) : ""
                } ${totalArtworks == 0 ? classNames(styles["disabled"]) : ""}`}
                onClick={() => {
                  setShowgalleries(false)
                  setShowartworks(true)
                  setShowexhibitions(false)
                }}>
                Artworks (<b>{totalArtworks}</b>)
              </a>
              <a
                className={`${
                  showgalleries ? classNames(styles["underline"]) : ""
                } ${
                  results.galleries.total == 0
                    ? classNames(styles["disabled"])
                    : ""
                }`}
                onClick={() => {
                  setShowgalleries(true)
                  setShowartworks(false)
                  setShowexhibitions(false)
                  setTotalArtworks(results.artworks.total)
                }}>
                Galleries (<b>{results.galleries.total}</b>)
              </a>
              <a
                className={`${
                  showexhibitions ? classNames(styles["underline"]) : ""
                } ${
                  results.exhibitions.total == 0
                    ? classNames(styles["disabled"])
                    : ""
                }`}
                onClick={() => {
                  setShowgalleries(false)
                  setShowartworks(false)
                  setShowexhibitions(true)
                  setTotalArtworks(results.artworks.total)
                }}>
                Exhibitions (<b>{results.exhibitions.total}</b>)
              </a>
            </div>
          </Container>
        </div>
        <Container className={styles.searchResultsContainer}>
          {noResults ? (
            <p className={styles.noResults}>No results match your search.</p>
          ) : (
            <>
              {showartworks && (
                <ArtworksResults
                  catalog={results.artworks}
                  onFilter={setTotalArtworks}
                  filters={filters}
                />
              )}
              {showgalleries && (
                <GalleriesResults
                  galleries={results.galleries}
                  searchTerm={searchTerm ? searchTerm.toUpperCase() : " "}
                />
              )}
              {showexhibitions && (
                <ExhibitionsResults
                  exhibitions={results.exhibitions}
                  searchTerm={searchTerm ? searchTerm.toUpperCase() : " "}
                />
              )}
            </>
          )}
        </Container>
      </Wrapper>
    </>
  )
}

export default Search
